.row {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 4);
  cursor: default;

  .item-info {
    align-items: center;
    flex: 1;
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    min-width: 0;
    color: var(--main-titles-inputs-600);
    .item-icon {
      width: calc(var(--spacer) * 3);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--chart-300-icon-buttons);
      .icon-tooltip {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon.icon-menu_risk_management:before {
          display: block;
          width: calc(var(--spacer) * 3);
          height: calc(var(--spacer) * 3);
          content: '';
          background: url("data:image/svg+xml,%3Csvg width='100%' height='100%' viewBox='0 0 32 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='ds-icon-menu_risk_management'%3E%3Cpath id='menu_ior' d='M21.1813 19.9133L16.7053 28.2727C16.6388 28.406 16.5402 28.5175 16.4198 28.5952C16.2993 28.6729 16.1616 28.7141 16.0213 28.7142H15.9866C15.8463 28.715 15.7084 28.6754 15.587 28.5996C15.4656 28.5238 15.3651 28.4144 15.296 28.2828L10.8186 19.9133L9.90129 21.2233L14.132 29.0378C14.3258 29.4008 14.6046 29.7025 14.9406 29.9127C15.2765 30.1228 15.6578 30.2341 16.0462 30.2352C16.4346 30.2364 16.8165 30.1275 17.1535 29.9193C17.4905 29.7112 17.771 29.4111 17.9666 29.0493V29.0378L22.2013 21.2262L21.1813 19.9133ZM5.52529 9.14791C5.5936 9.0144 5.6938 8.90305 5.81549 8.82542C5.93717 8.74778 6.07591 8.7067 6.21729 8.70642H11.7786V7.1792H6.20396C5.81738 7.17935 5.43775 7.29002 5.10375 7.49995C4.76975 7.70988 4.49332 8.01155 4.30262 8.37423V8.38573C4.10637 8.74764 4.00293 9.15935 4.00293 9.57861C4.00293 9.99787 4.10637 10.4096 4.30262 10.7715V10.76L7.59862 16.9293L8.53196 15.6192L5.52529 10.0007C5.45167 9.87089 5.41333 9.72141 5.41462 9.56926C5.4143 9.41706 5.45306 9.26773 5.52662 9.13784L5.52529 9.14791ZM27.7026 8.38573C27.5161 8.02082 27.2424 7.71645 26.9099 7.50427C26.5774 7.29209 26.1983 7.17984 25.812 7.1792L18.8093 7.1792V8.70642H25.7986C25.9365 8.70595 26.072 8.74582 26.1906 8.82179C26.3091 8.89776 26.4064 9.00699 26.472 9.13784C26.5456 9.26764 26.5839 9.41712 26.5826 9.56926C26.5829 9.72146 26.5442 9.87079 26.4706 10.0007L23.4813 15.6192L24.3986 16.9293L27.7013 10.7629C27.8975 10.401 28.001 9.98924 28.001 9.56998C28.001 9.15072 27.8975 8.73901 27.7013 8.37711V8.38861L27.7026 8.38573ZM15.2226 7.1792L11.5386 16.6388H15.8866V23.2769H16.5533L20.2373 13.8978H15.8866V7.1792H15.22H15.2226Z' fill='%237F7F7F'/%3E%3C/g%3E%3C/svg%3E%0A");
        }
      }
    }

    gz-tooltip {
      flex: 1;

      &.wrapper-tooltip {
        display: flex;
        justify-content: end;
      }

      .item-name {
        margin-left: calc(var(--spacer) * 1.5);
        display: inline;
        line-height: 17px;
      }
    }

    .item-score {
      display: flex;
      gap: var(--spacer);

      .item-severity-score {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: calc(var(--spacer) * 4);
        font-weight: 700;
        font-family: var(--font-family-secondary-mono);
      }

      .item-bullet {
        width: calc(var(--spacer) * 3);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .item-info:hover.is-clickable .icon.icon-menu_risk_management:before {
    background: url("data:image/svg+xml,%3Csvg width='100%' height='100%' viewBox='0 0 32 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='ds-icon-menu_risk_management'%3E%3Cpath id='menu_ior' d='M21.1813 19.9133L16.7053 28.2727C16.6388 28.406 16.5402 28.5175 16.4198 28.5952C16.2993 28.6729 16.1616 28.7141 16.0213 28.7142H15.9866C15.8463 28.715 15.7084 28.6754 15.587 28.5996C15.4656 28.5238 15.3651 28.4144 15.296 28.2828L10.8186 19.9133L9.90129 21.2233L14.132 29.0378C14.3258 29.4008 14.6046 29.7025 14.9406 29.9127C15.2765 30.1228 15.6578 30.2341 16.0462 30.2352C16.4346 30.2364 16.8165 30.1275 17.1535 29.9193C17.4905 29.7112 17.771 29.4111 17.9666 29.0493V29.0378L22.2013 21.2262L21.1813 19.9133ZM5.52529 9.14791C5.5936 9.0144 5.6938 8.90305 5.81549 8.82542C5.93717 8.74778 6.07591 8.7067 6.21729 8.70642H11.7786V7.1792H6.20396C5.81738 7.17935 5.43775 7.29002 5.10375 7.49995C4.76975 7.70988 4.49332 8.01155 4.30262 8.37423V8.38573C4.10637 8.74764 4.00293 9.15935 4.00293 9.57861C4.00293 9.99787 4.10637 10.4096 4.30262 10.7715V10.76L7.59862 16.9293L8.53196 15.6192L5.52529 10.0007C5.45167 9.87089 5.41333 9.72141 5.41462 9.56926C5.4143 9.41706 5.45306 9.26773 5.52662 9.13784L5.52529 9.14791ZM27.7026 8.38573C27.5161 8.02082 27.2424 7.71645 26.9099 7.50427C26.5774 7.29209 26.1983 7.17984 25.812 7.1792L18.8093 7.1792V8.70642H25.7986C25.9365 8.70595 26.072 8.74582 26.1906 8.82179C26.3091 8.89776 26.4064 9.00699 26.472 9.13784C26.5456 9.26764 26.5839 9.41712 26.5826 9.56926C26.5829 9.72146 26.5442 9.87079 26.4706 10.0007L23.4813 15.6192L24.3986 16.9293L27.7013 10.7629C27.8975 10.401 28.001 9.98924 28.001 9.56998C28.001 9.15072 27.8975 8.73901 27.7013 8.37711V8.38861L27.7026 8.38573ZM15.2226 7.1792L11.5386 16.6388H15.8866V23.2769H16.5533L20.2373 13.8978H15.8866V7.1792H15.22H15.2226Z' fill='%23349df7'/%3E%3C/g%3E%3C/svg%3E%0A");
  }
  .item-info.is-clickable {
    &:hover * {
      cursor: pointer;
      color: var(--blue-layout-301-active);
    }
  }
}

.gray-color::part(svgIcon) {
  color: var(--grey-layout-200-disabled);
}

.circle-icon::before {
  content: '';
  margin: 1px;
  width: calc(var(--spacer) * 1.5);
  height: calc(var(--spacer) * 1.5);
  background-color: var(--grey-layout-202-disabled-icons);
  border-radius: 50%;
}
